const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesLeftBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-22.064 22.877 104.619 454.898",
    width: 104.619,
    height: 454.898,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(213, 255, 234)",
      strokeWidth: 0
    },
    d: "M -21.269 114.635 L 13.966 32.16 C 22.388 22.899 64.559 51.887 62.561 61.007 L -1.909 132.64 C -3.868 136.893 -26.55 126.098 -21.269 114.635 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(218, 247, 255)",
      strokeLinejoin: "round"
    },
    d: "M 37.66 47.508 L 51.55 25.904 L 80.247 23.083 C 82.209 21.611 83.558 28.479 81.596 29.951 L 54.37 30.932 L 41.371 50.431 C 41.227 50.744 37.016 48.904 37.66 47.508 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(255, 255, 221)",
      fill: "rgb(248, 231, 255)"
    },
    d: "M 34.445 187.858 L -8.255 224.279 L -6.581 226.651 L 36.678 190.091 L 34.445 187.858 Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(213, 255, 249)",
      paintOrder: "fill",
      fillrule: "nonzero",
      fill: "rgb(255, 222, 253)"
    },
    cx: 53.035,
    cy: 169.445,
    rx: 27.58,
    ry: 27.58
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.516 188.766 Q 57.516 188.293 57.947 188.02 Q 58.406 187.729 59.007 187.905 Q 59.675 188.101 60.099 188.766 Q 60.575 189.514 60.499 190.488 Q 60.413 191.578 59.669 192.494 Q 58.844 193.51 57.516 193.932 Q 56.06 194.396 54.502 193.986 Q 52.81 193.54 51.551 192.21 Q 50.193 190.776 49.767 188.766 Q 49.31 186.614 50.059 184.461 Q 50.857 182.169 52.78 180.564 Q 54.818 178.863 57.516 178.434 Q 60.362 177.981 63.113 179.072 Q 66.003 180.219 67.955 182.739 Q 70 185.378 70.431 188.766 Q 70.882 192.305 69.447 195.654 Q 67.952 199.144 64.835 201.442 Q 61.595 203.832 57.516 204.265 Q 53.285 204.713 49.336 202.934 Q 45.248 201.091 42.603 197.376 Q 39.868 193.537 39.434 188.766 Q 38.987 183.843 41.111 179.295 Q 43.301 174.608 47.614 171.616 Q 52.054 168.536 57.516 168.101 Q 63.131 167.654 68.279 170.124 Q 73.565 172.66 76.903 177.573 Q 80.328 182.612 80.764 188.766 Q 81.21 195.074 78.395 200.82 Q 75.512 206.706 70.001 210.39 Q 64.362 214.161 57.516 214.597 Q 50.516 215.042 44.17 211.882 Q 37.686 208.652 33.654 202.542 Q 29.538 196.304 29.102 188.766 Q 28.657 181.074 32.163 174.129 Q 35.739 167.045 42.448 162.667 Q 49.286 158.206 57.516 157.769 Q 57.837 157.752 57.516 157.769",
    "data-bx-shape": "spiral 57.516 188.766 0 30.997 0 1080 1@af738b7a",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)"
    },
    transform: "matrix(0.84107, 0, 0, 0.862964, 6.681042, 6.224602)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(255, 230, 240)"
    },
    d: "M -6.695 404.879 C -11.677 408.267 47.309 436.553 56.204 430.505 L 21.683 476.673 C 12.421 481.464 -15.23 469.308 -8.178 465.66 L -6.695 404.879 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(224, 255, 228)"
    },
    d: "M 54.432 429.628 C 60.514 428.573 60.471 413.65 50.241 415.425 C 62.746 408.266 50.878 391.823 41.356 397.274 C 53.629 389.252 41.31 374.475 31.964 380.583 C 38.119 379.748 42.187 390.285 31.836 391.689 C 29.637 381.334 11.486 384 13.685 394.355 C 6.591 382.014 -11.813 392.168 -4.719 404.509 C -11.69 405.557 39.583 431.861 54.432 429.628 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(254, 205, 205)"
    },
    d: "M -3.158 284.734 L 4.413 274.239 C 4.451 273.786 8.58 274.302 8.542 274.755 L 31.943 248.602 C 33.723 247.101 41.981 253.467 40.201 254.968 L 25.06 287.659 C 25.594 287.303 26.238 292.953 25.92 293.165 L -2.814 345.644 L -3.158 284.734 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(234, 247, 221)"
    },
    d: "M 29.774 251.08 C 29.507 251.079 30.783 247.868 31.163 247.715 C 33.586 244.956 43.092 253.379 41.651 255.02 C 41.525 255.547 39.424 257.004 39.264 256.919 C 39.695 256.081 38.648 253.556 38.671 253.918 C 38.563 253.592 36.123 254.475 36.019 254.694 C 36.036 254.601 35.636 251.815 35.244 251.96 C 35.165 251.682 32.479 252.226 32.51 252.49 C 32.547 251.972 32.256 250.123 32.02 250.205 C 31.645 249.825 29.913 250.69 29.774 251.08 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesLeftBackground);
export default __webpack_public_path__ + "static/media/SalesLeftBackground.c308e8001743546a436b6a09d2666b32.svg";
export { ForwardRef as ReactComponent };